import { Image, Select, Table } from 'antd';
import axios from '../axios'
import '../styles/Inventory.css';

import { useEffect, useState } from 'react'
import getUsernamesFromUserId from '../modules/getUsernamesFromUserId';

function Inventory() {
    const [BGRap, setBGRap] = useState([])
    const [huges, setHuges] = useState([])
    const [players, setPlayers] = useState([])
    const [selectedPlayer, setSelectedPlayer] = useState('all');
    const [server, setServer] = useState(() => {
        const server = localStorage.getItem('selectedServer');
        return server ? JSON.parse(server) : null;
    });
    const [pageSize, setPageSize] = useState(10); // Add state for page size

    useEffect(() => {
        fetch("https://ps99.biggamesapi.io/api/rap", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then(res => res.json()).then(data => {
            setBGRap(data);
        })

        axios.get(`/api/user/inventory/${server?.id}`)
            .then((res) => {
                setHuges(res.data);
            })
            .catch((err) => {
                console.log(err);
                window.location.reload();
            });

        axios.get(`/api/user/player/${server?.id}`)
            .then(async (res) => {
                var playerIds = res.data.map(data => data.robloxUserId);
                var usernames = await getUsernamesFromUserId(playerIds);
                res.data.forEach(element => {
                    element.username = usernames.find(u => u.id === element.robloxUserId).name;
                });
                setPlayers(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [])

    const columns = [
        {
            title: 'Icon',
            dataIndex: 'hugeThumbnail',
            key: 'thumbnail',
            render: (text, record) => (
                <Image width={50} src={`https://ps99.biggamesapi.io/image/${record.thumbnail}`} preview={false} />
            )
        },
        {
            title: 'Huge Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Variant',
            dataIndex: 'variantType',
            key: 'variant',
            sorter: (a, b) => a.variantId - b.variantId,
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
        },
        {
            title: 'RAP',
            dataIndex: 'rap',
            key: 'rap',
        },
    ];

    const handleTableChange = (pagination) => {
        setPageSize(pagination.pageSize);
    };

    const filteredHuges = selectedPlayer === 'all' ? huges : huges.filter(data => data.playerId === selectedPlayer) || [];

    return (
        <div className='section-2'>
            <Select
                defaultValue={selectedPlayer}
                style={{ width: 150, textAlign: 'center' }}
                options={[{ label: 'All Players', value: 'all' }, ...players.map(data => ({ label: data.username, value: data.id }))]}
                onChange={value => setSelectedPlayer(value)}
            />
            <Table
                className='section-2-table'
                dataSource={filteredHuges}
                columns={columns}
                rowKey="id"
                scroll={{ y: window.innerHeight - 300 }} // Adjust the height dynamically based on window height
                pagination={{
                    pageSize, // Controlled by state
                    showSizeChanger: true, // Enable page size dropdown
                    pageSizeOptions: ['10', '20', '50', '100'], // Custom options
                    onShowSizeChange: (current, size) => setPageSize(size), // Update state on change
                }}
            />
        </div>
    )
}

export default Inventory
